// extracted by mini-css-extract-plugin
export default {"messageContainer":"_8D7+u","icon":"HnHP7","text":"BnDef"};